import React from 'react'

import Link from 'next/link'

// Components
import ButtonCall from '@/components/puppyProfile/lib/buttonCall'
import Header from '@/components/newHeader/Header'
import Footer from '@/components/newFooter'
import BasicHeadSeo from '@/components/basicHeadSeo'
import styles from './contact.module.scss'
import { ROBOTS_META } from 'const'

const Team = ({ title, question, contact }) => {
  return (
    <div className={styles.box}>
      <h3>{title}</h3>
      <p>{question}</p>
      <p>
        Drop us an email at <a href={`mailto:${contact}`}>{contact}</a>
      </p>
    </div>
  )
}

const contactUs = () => {
  const teamData = [
    {
      title: 'Sales',
      question:
        'Do you have a question about a specific puppy or our Sales process?',
      contact: 'sales@mawoopets.com',
    },
    {
      title: 'Support',
      question:
        'Submitted a deposit for a specific puppy and have questions about getting your newest family member home?',
      contact: 'support@mawoopets.com',
    },
    {
      title: 'Breeders',
      question:
        'Do you want to join Mawoo Pets’s network of vetted breeders? Have any question as an existing breeder?',
      contact: 'breeders@mawoopets.com',
    },
  ]
  return (
    <>
      <BasicHeadSeo
        title="Contact Us | MawooPets.com"
        description="Contact Mawoo Pets. Find email, phone, and chat information for Mawoo Pets, including for sales, support, and breeder help."
        image={`${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`}
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/contact`}
        content={ROBOTS_META}
      />

      <main className={styles.main}>
        <Header />
        <div className={styles.contactContainer}>
          <div className={styles.titlesContainer}>
            <h1>Hi, how can we help?</h1>
            <h4>
              Get in touch with a member of our team and and let us know how we
              can help.
            </h4>
          </div>

          <div className={styles.buttonsContainer}>
            <h2>Contact our team Mon-Sat 9a-9p ET.</h2>
            <div className={styles.buttons}>
              <ButtonCall />
            </div>
          </div>

          <div className={styles.emailContainer}>
            <h2>Or via email</h2>
            <div className={styles.teamsBoxContainer}>
              {teamData.map((team, i) => (
                <Team key={i} {...team} />
              ))}
            </div>
            <h2>
              Or check our<Link href="/faq/customer"> FAQs</Link>
            </h2>
          </div>
        </div>
        <Footer />
      </main>
    </>
  )
}

export default contactUs
